import yup from 'utils/yupIBAN';

export const contactSchema = (hasStep3: boolean, hasVoucher: boolean, directPay: boolean) => {
  let schemaFields: { [key: string]: yup.AnySchema } = {
    confirmCompany: yup.boolean().oneOf([true], 'form.employee.error.checkbox.required'),
    confirmPrivacy: yup.boolean().oneOf([true], 'form.employee.error.checkbox.required'),
  };

  if (hasStep3 && !hasVoucher) {
    schemaFields.confirmPayments = yup
      .boolean()
      .oneOf([true], 'form.employee.error.checkbox.required');
  }

  if (directPay) {
    schemaFields.confirmContractPolicy = yup
      .boolean()
      .oneOf([true], 'form.employee.error.checkbox.required');
  }

  return yup.object(schemaFields).required();
};

export default contactSchema;
